export const US_STATES = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DC',
  'DE',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
] as const

export type USState = (typeof US_STATES)[number]

export const UNIT_OPTIONS = ['Tablets', 'Capsules', 'Films', 'Troches', 'Patches', 'Tube'] as const

export const SIGNATURE_REQUIRED_OPTIONS = [
  { value: 'never', label: 'Never' },
  { value: 'always', label: 'Always' },
  { value: 'controlledsubstancesonly', label: 'Controlled substances only' },
] as const

export function formatNdc(raw: string): string {
  const d = raw.replace(/\D/g, '')
  if (d.length <= 5) return d
  if (d.length <= 9) return `${d.slice(0, 5)}-${d.slice(5)}`
  return `${d.slice(0, 5)}-${d.slice(5, 9)}-${d.slice(9, 11)}`
}
